import LocaleProvider from './locale-provider';
export default LocaleProvider;



// WEBPACK FOOTER //
// ./components/locale-provider/index.tsx